import {
  CATEGORY_COLORS,
  CATEGORY_TYPES,
  type CategoryType,
} from "@/lib/icons/categories";

export type SortDir = "asc" | "desc";

const CATEGORY_TYPE_SET = new Set<string>(CATEGORY_TYPES);

/**
 * The colour to tint a category pill/icon: the catalog colour if present,
 * otherwise the design-system palette keyed by slug, otherwise undefined
 * (caller renders a neutral fallback).
 */
export function categoryColor(
  slug?: string,
  color?: string,
): string | undefined {
  if (color) return color;
  if (slug && CATEGORY_TYPE_SET.has(slug))
    return CATEGORY_COLORS[slug as CategoryType];
  return undefined;
}

/** Narrows a DB category slug to a known EntityIcon category, or null. */
export function asCategoryType(slug?: string): CategoryType | null {
  return slug && CATEGORY_TYPE_SET.has(slug) ? (slug as CategoryType) : null;
}
